'use client';
import { useEffect, useState } from 'react';
import StackTestLayout from './stack-test-layout';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setStackTestData } from '@/redux/slices/stack-test/stackTestSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflineStackTestProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflineStackTest({ projectId, isOffline }: OfflineStackTestProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadStackTestData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);
          
          if (project?.stackTestData) {
            dispatch(setStackTestData(project.stackTestData));
          }
        } catch (error) {
          console.error('Error loading stack test data:', error);
          showErrorToast('Failed to load stack test configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadStackTestData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          stackTestData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Stack test data saved offline");
      }
    } catch (error) {
      console.error('Error saving stack test data:', error);
      showErrorToast("Failed to save stack test data");
    }
  };

  if (isLoading) {
    return <div>Loading stack test configuration...</div>;
  }

  return (
    <StackTestLayout 
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
} 